type HkgInfoList = {
  [key: string]: {
    streetList: string[];
  };
};

export const HKG_BANK_LIST = [
  'AAREAL BANK AG, WIESBADEN, GERMANY [552]',
  'ABN AMRO BANK N.V. [307]',
  'AGRICULTURAL BANK OF CHINA LIMITED FRANKFURT BRANCH [A10]',
  'AGRICULTURAL BANK OF CHINA LIMITED [222]',
  'AGRICULTURAL BANK OF CHINA LIMITED, SINGAPORE BRANCH [340]',
  'AGRICULTURAL BANK OF CHINA, BEIJING [400]',
  'AIRSTAR BANK LIMITED [395]',
  'ALLAHABAD BANK [256]',
  'ALLIED BANKING CORPORATION (HK) LTD. [402]',
  'ANT BANK (HONG KONG) LIMITED [393]',
  'AUSTRALIA AND NEW ZEALAND BANKING GROUP LTD [152]',
  'AXIS BANK LIMITED [261]',
  'BANCA MONTE DEI PASCHI DI SIENA S.P.A. - HONG KONG BRANCH [234]',
  'BANCO BILBAO VIZCAYA ARGENTARIA, S.A. [147]',
  'BANCO DO BRASIL S. A., TOKYO BRANCH [356]',
  'BANCO SANTANDER, S.A. [267]',
  'BANGKOK BANK PUBLIC COMPANY LTD [049]',
  'BANK FOR FOREIGN TRADE OF VIETNAM [553]',
  'BANK J. SAFRA SARASIN LTD [278]',
  'BANK JULIUS BAER & CO. LTD. [320]',
  'BANK OF AMERICA, NATIONAL ASSOCIATION [055]',
  'BANK OF BARODA [259]',
  'BANK OF CHINA (ELUOSI) [283]',
  'BANK OF CHINA (HONG KONG) LIMITED [012]',
  'BANK OF CHINA (HONG KONG) LIMITED [014]',
  'BANK OF CHINA (HONG KONG) LIMITED [019]',
  'BANK OF CHINA (HONG KONG) LIMITED [026]',
  'BANK OF CHINA (HONG KONG) LIMITED [030]',
  'BANK OF CHINA (HONG KONG) LIMITED [031]',
  'BANK OF CHINA (HONG KONG) LIMITED [033]',
  'BANK OF CHINA (HONG KONG) LIMITED [036]',
  'BANK OF CHINA (HONG KONG) LIMITED [064]',
  'BANK OF CHINA (HONG KONG) LIMITED [070]',
  'BANK OF CHINA (HUNGARY) CLOSE LIMITED [290]',
  'BANK OF CHINA (MALAYSIA) BERHAD [282]',
  'BANK OF CHINA LIMITED JAKARTA BRANCH [284]',
  'BANK OF CHINA LIMITED JOHANNESBURG BRANCH [298]',
  'BANK OF CHINA LIMITED LUXEMBOURG BRANCH [301]',
  'BANK OF CHINA LIMITED MANILA BRANCH [279]',
  'BANK OF CHINA LIMITED MILAN BRANCH [291]',
  'BANK OF CHINA LIMITED NEW YORK BRANCH [304]',
  'BANK OF CHINA LIMITED PARIS BRANCH [303]',
  'BANK OF CHINA LIMITED PHNOM PENH BRANCH [327]',
  'BANK OF CHINA LIMITED SEOUL BRANCH [285]',
  'BANK OF CHINA LIMITED SINGAPORE BRANCH [286]',
  'BANK OF CHINA LIMITED SYDNEY BRANCH [288]',
  'BANK OF CHINA LIMITED TAIPEI BRANCH [A00]',
  'BANK OF CHINA LIMITED TOKYO BRANCH [280]',
  'BANK OF CHINA LIMITED, HONG KONG BRANCH [338]',
  'BANK OF CHINA LIMITED, PANAMA BRANCH [311]',
  'BANK OF CHINA LONDON BRANCH [292]',
  'BANK OF CHINA LTD. - ABU DHABI [A12]',
  'BANK OF CHINA, LUXEMBOURG S.A. [300]',
  'BANK OF COMMUNICATIONS CO., LTD. HEAD OFFICE, SHANGHAI [428]',
  'BANK OF COMMUNICATIONS CO., LTD. SHENZHEN BRANCH [429]',
  'BANK OF COMMUNICATIONS CO., LTD. [027]',
  'BANK OF COMMUNICATIONS HONG KONG LIMITED [382]',
  'BANK OF COMMUNICATIONS SEOUL BRANCH [349]',
  'BANK OF HANGZHOU, HANGZHOU [555]',
  'BANK OF INDIA [058]',
  'BANK OF JIANGSU CO. LTD., NANJING [506]',
  'BANK OF MONTREAL [086]',
  'BANK OF MONTREAL, GUANGZHOU BRANCH [542]',
  'BANK OF NINGBO CO. LTD., ZHEJIANG [478]',
  'BANK OF SHANGHAI (HONG KONG) LIMITED [372]',
  'BANK OF SINGAPORE LIMITED [272]',
  'BANK OF TAIWAN [201]',
  'BANK SINOPAC [241]',
  'BANK SINOPAC [244]',
  'BANK SINOPAC, LOS ANGELES BRANCH [355]',
  'BANK SINOPAC, TAIPEI [431]',
  'BARCLAYS BANK PLC [074]',
  'BDO UNIBANK, INC. [067]',
  'BDO UNIBANK, INC. [BNORHKHH]',
  'BNP PARIBAS SECURITIES SERVICES [275]',
  'BNP PARIBAS WEALTH MANAGEMENT [240]',
  'BNP PARIBAS [056]',
  'BOC CREDIT CARD (INTERNATIONAL) LIMITED [252]',
  'BSI LTD [350]',
  'CAMBODIA MEKONG BANK PUBLIC LIMITED [351]',
  'CANADIAN IMPERIAL BANK OF COMMERCE [092]',
  'CANADIAN IMPERIAL BANK OF COMMERCE, CANADA [366]',
  'CANARA BANK [262]',
  'CATHAY BANK [263]',
  'CATHAY UNITED BANK COMPANY, LIMITED [236]',
  'CHANG HWA COMMERCIAL BANK LTD [206]',
  'CHANGSHA CITY COMMERCIAL BANK [529]',
  'CHINA CITIC BANK INTERNATIONAL LIMITED [018]',
  'CHINA CITIC BANK INTERNATIONAL LIMITED [051]',
  'CHINA CITIC BANK, BEIJING [437]',
  'CHINA CONSTRUCTION BANK (ASIA) CORPORATION LIMITED [009]',
  'CHINA CONSTRUCTION BANK (ASIA) CORPORATION LIMITED [CCBQHKAXWHS]',
  'CHINA CONSTRUCTION BANK CORPORATION [221]',
  'CHINA CONSTRUCTION BANK SEOUL BRANCH [358]',
  'CHINA DEVELOPMENT BANK CORPORATION [276]',
  'CHINA EVERBRIGHT BANK CO., LTD [368]',
  'CHINA EVERBRIGHT BANK, BEIJING [434]',
  'CHINA GUANGFA BANK CO. LTD, BEIJING [447]',
  'CHINA GUANGFA BANK CO., LTD. GUANGZHOU [549]',
  'CHINA MERCHANTS BANK CO., LTD, SINGAPORE BRANCH [A09]',
  'CHINA MERCHANTS BANK CO., LTD. [238]',
  'CHINA MERCHANTS BANK, HEAD OFFICE, SHENZHEN [435]',
  'CHINA MINSHENG BANKING CORP., LTD. [353]',
  'CHINA MINSHENG BANKING CORPORATION LTD., BEIJING [436]',
  'CHINA RESOURCES BANK OF ZHUHAI CO LTD., ZHUHAI [507]',
  'CHIYU BANKING CORPORATION LTD [039]',
  'CHONG HING BANK LTD [041]',
  'CIMB BANK BERHAD [374]',
  'CIMB THAI BANK PUBLIC COMPANY LIMITED [343]',
  'CITIBANK (CHINA) CO LTD, SHENZHEN BRANCH [531]',
  'CITIBANK (HONG KONG) LIMITED [250]',
  'CITIBANK N.A. [006]',
  'COMMERZBANK AG [097]',
  'COMMONWEALTH BANK OF AUSTRALIA [153]',
  'CONCORD BANK LTD., NINGBO [524]',
  'CONTINUOUS LINKED SETTLEMENT BANK INTERNATIONAL [868]',
  'COOPERATIEVE CENTRALE RAIFFEISEN-BOERENLEENBANK B.A. (TRADIN [323]',
  'COOPERATIEVE CENTRALE RAIFFEISEN-BOERENLEENBANK B.A. [183]',
  'COOPERATIEVE CENTRALE RAIFFEISEN-BOERENLEENBANK B.A.(TRADING [319]',
  'COUTTS & CO LTD [205]',
  'COUTTS AND CO. LTD., SINGAPORE [513]',
  'CREDIT AGRICOLE (SUISSE) S.A. [339]',
  'CREDIT AGRICOLE CIB [CRLYHKHH]',
  'CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK [005]',
  'CREDIT SUISSE AG [233]',
  'CTBC BANK CO., LTD. [229]',
  'DAH SING BANK LTD [040]',
  'DBS BANK (HONG KONG) LIMITED [016]',
  'DBS BANK LTD, HONG KONG BRANCH (INCORPORATED IN SINGAPORE WI [DBSSHKHH]',
  'DEUTSCHE BANK AG [054]',
  'DNB NOR BANK ASA, SINGAPORE BRANCH [328]',
  'DONGGUAN RURAL CREDIT COOPERATIVES UNION, DONGGUAN [439]',
  'DZ BANK AG DEUTSCHE ZENTRAL-GENOSSENSCHAFTSBANK [113]',
  'E.SUN COMMERCIAL BANK, LTD [243]',
  'E.SUN COMMERCIAL BANK, LTD., TAIPEI [557]',
  'EAST WEST BANK [258]',
  'EDMOND DE ROTHSCHILD (SUISSE) S.A. [346]',
  'EFG BANK AG [237]',
  'ERSTE GROUP BANK AG [227]',
  'EXPORT-IMPORT BANK OF THAILAND, BANGKOK [440]',
  'FALCON PRIVATE BANK LTD. [253]',
  'FAR EASTERN INTERNATIONAL BANK [260]',
  'FINABANK N.V. [362]',
  'FIRST COMMERCIAL BANK [203]',
  'FUBON BANK (HONG KONG) LIMITED [128]',
  'FUSION BANK LIMITED [391]',
  'GRANIT BANK ZRT [325]',
  'GUIYANG COMMERCIAL BANK, GUIYANG [540]',
  'HABIB BANK ZURICH (HONG KONG) LIMITED [322]',
  'HANA BANK [112]',
  'HANG SENG BANK LTD [024]',
  'HDFC BANK LTD. [308]',
  'HKT Payment Limited [935]',
  'HONG KONG MONETARY AUTHORITY [888]',
  'HONG LEONG BANK BERHAD [248]',
  'HSBC - THE HONGKONG AND SHANGHAI BANKING CORPORATION LTD [004]',
  'HSBC BANGLADESH [450]',
  'HSBC BANK (TAIWAN) LIMITED [464]',
  'HSBC BANK MALAYSIA BERHAD [457]',
  'HSBC BANK PLC [347]',
  'HSBC BANK USA, NATIONAL ASSOCIATION [106]',
  'HSBC BANK VIETNAM LTD [466]',
  'HSBC BRUNEI [451]',
  'HSBC INDIA [452]',
  'HSBC INDONESIA [453]',
  'HSBC JAPAN [454]',
  'HSBC MANILA [458]',
  'HSBC PRIVATE BANK (SUISSE) SA [235]',
  'HSBC SEOUL BRANCH [460]',
  'HSBC SINGAPORE [462]',
  'HSBC SRI LANKA [463]',
  'HSBC THAILAND [465]',
  'HUA NAN COMMERCIAL BANK LTD [198]',
  'HUA NAN COMMERCIAL BANK LTD., TAIPEI [550]',
  'HUA XIA BANK, BEIJING [468]',
  'ICBC STANDARD BANK PLC [341]',
  'ICICI BANK LIMITED [251]',
  'INDIAN OVERSEAS BANK [050]',
  'INDIAN OVERSEAS BANK, HONG KONG [IOBAHKHHTST]',
  'INDIAN OVERSEAS BANK, HONG KONG [IOBAHKHH]',
  'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (ASIA) LTD [029]',
  'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (ASIA) LTD [072]',
  'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (MALAYSIA) BERHAD [330]',
  'INDUSTRIAL AND COMMERCIAL BANK OF CHINA LIMITED [214]',
  'INDUSTRIAL AND COMMERCIAL BANK OF CHINA, BEIJING [469]',
  'INDUSTRIAL BANK CO., LTD. HONG KONG BRANCH [FJIBHKHH]',
  'INDUSTRIAL BANK CO., LTD. [377]',
  'INDUSTRIAL BANK COMPANY LTD., FUZHOU [445]',
  'INDUSTRIAL BANK OF KOREA [271]',
  'INDUSTRIAL BANK OF KOREA, HONG [IBKOHKHH]',
  'INDUSTRIAL BANK OF TAIWAN CO., LTD. [274]',
  'INDUSTRIAL BANK OF TAIWAN, TAIPEI [470]',
  'ING BANK N.V. [145]',
  'INTESA SANPAOLO S.P.A. [161]',
  'J.P. MORGAN SECURITIES (ASIA PACIFIC) LIMITED [375]',
  'JIANG YIN RURAL COMMERCIAL BANK, JIANG YIN CITY, JIANG SU [541]',
  "JOINT STOCK COMMERCIAL BANK 'LANTA-BANK' (CJSC) [317]",
  'JOINT STOCK COMMERCIAL BANK FOR INVESTMENT AND DEVELOPMENT O [407]',
  'JPMORGAN CHASE BANK, N.A., HONG KONG BRANCH [CHASHKHP863]',
  'JPMORGAN CHASE BANK, N.A., HONG KONG [007]',
  'JSC AB (BANK OF CHINA KAZAKHSTAN) [305]',
  'JSC CAPITAL BANK [A06]',
  'KASIKORNBANK PUBLIC COMPANY LIMITED [380]',
  'KBC BANK N.V. [178]',
  'KDB ASIA LIMITED [318]',
  'KEB ASIA FINANCE LIMITED [363]',
  'KEB HANA BANK [KOEXHKHH]',
  'KOREA EXCHANGE BANK [046]',
  'KOREA EXCHANGE BANK, KOREA [A02]',
  'LAND BANK OF TAIWAN CO., LTD. HONG KONG [LBOTHKHH]',
  'LAND BANK OF TAIWAN CO., LTD. [264]',
  'LGT BANK AG [342]',
  'LGT BANK AG, HONG KONG BRANCH [BLFLHKHH]',
  'LIVI BANK LIMITED [388]',
  'LIVI BANK LIMITED [LIVIHKHHXXX]',
  'LLOYDS TSB PACIFIC LIMITED [LOYDHKHH]',
  'MACQUARIE BANK LIMITED [344]',
  'MANULIFE (INTERNATIONAL) LIMITED [MFCTHKHHXXX]',
  'MASHREQ BANK - PUBLIC SHAREHOLDING COMPANY [379]',
  'MASHREQBANK PSC [352]',
  'MAYBANK (MALAYAN BANKING BERHAD) [063]',
  'MEGA INTERNATIONAL COMMERCIAL BANK CO., LTD. [242]',
  'MEGA INTERNATIONAL COMMERCIAL BANK CO., LTD., HK [ICBCHKHH]',
  'MELLI BANK PLC [254]',
  'METROPOLITAN BANK & TRUST COMPANY [295]',
  'MITSUBISHI UFJ TRUST AND BANKING CORPORATION [138]',
  'MIZUHO BANK, LTD. [109]',
  'MUFG BANK, LTD. [BOTKHKHH]',
  'Mox Bank Limited [389]',
  'NANYANG COMMERCIAL BANK LTD [043]',
  'NATIONAL AUSTRALIA BANK LTD [150]',
  'NATIONAL BANK OF ABU DHABI [277]',
  'NATIONAL BANK OF CANADA [331]',
  'NATIONAL BANK OF PAKISTAN [060]',
  'NATIXIS [210]',
  'OCBC WING HANG BANK LIMITED [035]',
  'OCBC WING HANG BANK LIMITED [044]',
  'ORIENT EXPRESS BANK [367]',
  'ORIX ASIA LIMITED [373]',
  'OVERSEA-CHINESE BANKING CORPORATION LTD [022]',
  'PHILIPPINE NATIONAL BANK [119]',
  'PICTET & CIE (EUROPE) S.A. [357]',
  'PING AN BANK CO., LTD, SHENZHEN [485]',
  'PORTIGON AG [218]',
  'PT BANK CENTRAL ASIA TBK, INDONESIA [281]',
  'PT. BANK MANDIRI (PERSERO) TBK, HONG KONG BRANCH [480]',
  'PT. BANK NEGARA INDONESIA (PERSERO) TBK. [066]',
  'PUBLIC BANK (HONG KONG) LIMITED [028]',
  'PUNJAB NATIONAL BANK [266]',
  'RAIFFEISEN BANK INTERNATIONAL AG [370]',
  'RAIFFEISEN BANK INTERNATIONAL AG, SINGAPORE BRANCH [354]',
  'ROYAL BANK OF CANADA [080]',
  'SAIGON THUONG TIN COMMERCIAL JOINT STOCK BANK [296]',
  'SHANGHAI COMMERCIAL BANK LTD [025]',
  'SHANGHAI PUDONG DEVELOPMENT BANK CO., LTD [345]',
  'SHANGHAI PUDONG DEVELOPMENT BANK [SPDBHKHH]',
  'SHANGHAI PUDONG DEVELOPMENT BANK, SHANGHAI [484]',
  'SHENZHEN DEVELOPMENT BANK, SHENZHEN [486]',
  'SHENZHEN RURAL COMMERCIAL BANK [509]',
  'SHINHAN BANK [273]',
  'SKANDINAVISKA ENSKILDA BANKEN AB [316]',
  'SOCIETE GENERALE BANK & TRUST [255]',
  'SOCIETE GENERALE [081]',
  'STANDARD CHARTERED BANK (HONG KONG) LIMITED - EURO CLEARING [818]',
  'STANDARD CHARTERED BANK (HONG KONG) LIMITED [003]',
  'STANDARD CHARTERED BANK HONG KONG BRANCH [249]',
  'STANDARD CHARTERED BANK PLC, LONDON [536]',
  'STANDARD CHARTERED BANK, BANGKOK [521]',
  'STANDARD CHARTERED BANK, BEIJING BRANCH [489]',
  'STANDARD CHARTERED BANK, JAKARTA BRANCH [515]',
  'STANDARD CHARTERED BANK, MALAYSIA BERHAD [519]',
  'STANDARD CHARTERED BANK, NANJING BRANCH [490]',
  'STANDARD CHARTERED BANK, PHILIPPINES BRANCH [517]',
  'STANDARD CHARTERED BANK, SEOUL KOREA [518]',
  'STANDARD CHARTERED BANK, SHANGHAI BRANCH [491]',
  'STANDARD CHARTERED BANK, SHENZHEN BRANCH [492]',
  'STANDARD CHARTERED BANK, SINGAPORE BRANCH [516]',
  'STANDARD CHARTERED BANK, SRI LANKA [522]',
  'STANDARD CHARTERED BANK, TAIWAN [520]',
  'STANDARD CHARTERED BANK, TIANJIN BRANCH [493]',
  'STANDARD CHARTERED BANK, TOKYO [A07]',
  'STANDARD CHARTERED BANK, XIAMEN BRANCH [494]',
  'STANDARD CHARTERED BANK, ZHUHAI BRANCH [495]',
  'STATE BANK OF INDIA [082]',
  'STATE STREET BANK AND TRUST COMPANY [220]',
  'SUMITOMO MITSUI BANKING CORPORATION [065]',
  'SUMITOMO MITSUI TRUST BANK, LIMITED [371]',
  'SUNNY BANK, TAIPEI [496]',
  'SVENSKA HANDELSBANKEN AB (PUBL) [165]',
  'TA CHONG BANK, LTD. [378]',
  'TAI SANG BANK LTD [061]',
  'TAI YAU BANK LTD [038]',
  'TAICHUNG COMMERCIAL BANK, TAICHUNG [498]',
  'TAIPEI FUBON COMMERCIAL BANK CO., LTD. [239]',
  'TAISHIN INTERNATIONAL BANK CO., LTD [245]',
  'TAISHIN INTERNATIONAL BANK, TAIPEI [499]',
  'TAIWAN BUSINESS BANK HONG KONG BRANCH [230]',
  'TAIWAN BUSINESS BANK HONG KONG BRANCH [MBBTHKHH]',
  'TAIWAN COOPERATIVE BANK, HONG KONG BRANCH [TACBHKHH]',
  'TAIWAN COOPERATIVE BANK, LTD. [265]',
  'TAIWAN SHIN KONG COMMERCIAL BANK CO., LTD. [337]',
  'TAIWAN SHIN KONG COMMERCIAL BANK COMPANY LIMITED, TAIPEI [474]',
  'THE BANK OF BERMUDA LIMITED, HONG KONG BRANCH [502]',
  'THE BANK OF EAST ASIA, LTD [015]',
  'THE BANK OF NEW YORK MELLON [139]',
  'THE BANK OF NOVA SCOTIA [076]',
  'THE BANK OF NOVA SCOTIA, SINGAPORE [329]',
  'THE BANK OF TOKYO-MITSUBISHI UFJ, LTD. [047]',
  'THE CHIBA BANK LTD [170]',
  'THE CHUGOKU BANK LTD [202]',
  'THE HACHIJUNI BANK, LTD [188]',
  'THE HONGKONG AND SHANGHAI BANKING CORPORATION LTD - USD CLEA [828]',
  'THE HOUSING BANK FOR TRADE AND FINANCE, JORDAN [554]',
  'THE IYO BANK LTD [224]',
  'THE ROYAL BANK OF SCOTLAND N.V. [360]',
  'THE ROYAL BANK OF SCOTLAND PLC [008]',
  'THE RURAL CREDIT COOPERATIVES UNION OF SHUNDE [528]',
  'THE SHANGHAI COMMERCIAL & SAVINGS BANK LTD [269]',
  'THE SHIGA BANK, LTD. [199]',
  'THE SHIZUOKA BANK, LTD [186]',
  'THE SIAM COMMERCIAL BANK PUBLIC COMPANY LIMITED [487]',
  'THE TORONTO-DOMINION BANK [085]',
  'TMB BANK PUBLIC COMPANY LIMITED, BANGKOK [500]',
  'TMB BANK PUBLIC COMPANY LIMITED, HONG KONG [501]',
  'TURK EKONOMI BANKASI A.S. [312]',
  'UBS AG, HONG KONG [103]',
  'UCO BANK [045]',
  'UNICREDIT BANK AG HONG KONG BRANCH [BVBEHKHH]',
  'UNICREDIT BANK AG [164]',
  'UNION BANK OF INDIA [268]',
  'UNITED OVERSEAS BANK LTD [071]',
  'UNITED SUBURBAN AND RURAL CREDIT COOPERATIVE WUXI, WUXI [504]',
  'VIETNAM JOINT STOCK COMMERCIAL BANK FOR INDUSTRY AND TRADE [293]',
  'VIETNAM TECHNOLOGICAL AND COMMERCIAL JOINT STOCK BANK, HANOI [505]',
  'WELAB BANK LIMITED [390]',
  'WELLS FARGO BANK, N.A. [180]',
  'WELLS FARGO BANK, N.A., LONDON BRANCH [297]',
  'WESTPAC BANKING CORPORATION [151]',
  'WING LUNG BANK LTD [020]',
  'WOORI BANK [118]',
  'WOORI BANK, KOREA [A05]',
  'XIAMEN BANK CO., LTD., XIAMEN [547]',
  'ZA BANK LIMITED [387]',
  'ZA BANK LIMITED [AABLHKHH]',
  'ZAO INDUSTRIAL AND COMMERCIAL BANK OF CHINA (MOSCOW) [A04]',
  'ZIBO CITY COMMERCIAL BANK, SHANDONG [525]',
];

export const HKG_INFO_LIST: HkgInfoList = {
  Hongkong: {
    streetList: [
      'Central and Western',
      'Eastern',
      'Southern',
      'Wan Chai',
      'Direct Input',
    ],
  },
  Kowlong: {
    streetList: [
      'Kowlong City',
      'Kwun Tong',
      'Sham Shui Po',
      'Wong Tai Sin',
      'Yau Tsim Mong',
      'Direct Input',
    ],
  },
  'The New Territories': {
    streetList: [
      'Islands',
      'Kwai Tsing',
      'North',
      'Sai Kung',
      'Sha Tin',
      'Tai Po',
      'Tsuen Wan',
      'Then Mun',
      'Yuen Long',
      'Direct Input',
    ],
  },
};
